import { createStore } from 'vuex'
import auth from './modules/auth'
import developer from './modules/developer'
import session from './modules/session'
import chat from './modules/chat'

export default createStore({
  state: {
    users: [],
    loading: false,
    error: null
  },
  getters: {
    getUsers: state => state.users,
    isLoading: state => state.loading,
    getError: state => state.error
  },
  mutations: {
    SET_USERS(state, users) {
      state.users = users
    },
    SET_LOADING(state, loading) {
      state.loading = loading
    },
    SET_ERROR(state, error) {
      state.error = error
    },
    ADD_USER(state, user) {
      state.users.push(user)
    }
  },
  actions: {
    async fetchUsers({ commit }) {
      commit('SET_LOADING', true)
      try {
        const token = localStorage.getItem('authToken')
        const response = await fetch('http://localhost:5000/api/users', {
          headers: {
            'Authorization': `Bearer ${token}`
          }
        })
        
        if (response.ok) {
          const users = await response.json()
          commit('SET_USERS', users)
        } else {
          const errorData = await response.json()
          commit('SET_ERROR', errorData.message || 'Failed to fetch users')
        }
      } catch (error) {
        commit('SET_ERROR', error.message)
      } finally {
        commit('SET_LOADING', false)
      }
    }
  },
  modules: {
    auth,
    developer,
    session,
    chat
  }
}) 